var exports = {
  "Zd": "AddFriendForm.module__form___djVTQj",
  "kL": "AddFriendForm.module__container___djVTQj",
  "QX": "AddFriendForm.module__containerDesktop___djVTQj",
  "hF": "AddFriendForm.module__input___djVTQj",
  "Rq": "AddFriendForm.module__inputDesktop___djVTQj",
  "Xu": "AddFriendForm.module__inputError___djVTQj",
  "x6": "AddFriendForm.module__button___djVTQj",
  "oR": "AddFriendForm.module__inlineButton___djVTQj",
  "gJ": "AddFriendForm.module__errorMessage___djVTQj",
  "Jl": "AddFriendForm.module__successMessage___djVTQj",
};

module.exports = exports;
